module.exports = __webpack_public_path__ + "img/flying-clouds.57c3cd11.svg";